import { classNames, Tile } from '@op/opds.opux';
import styles from './CoverageSection.module.scss';
import CriticalIllness from '../CriticalIllness';
import LifeInsurance from '../LifeInsurance';
import PermanentDisability from '../PermanentDisability';
import TemporaryDisability from '../TemporaryDisability';
import { CoverageProduct } from 'dto/marketableProduct';
import i18n from 'i18n';
import { useAvailableCoverages } from 'state/selectors/coverageSelectors';
import { useAppStore } from 'state/store';

const coverageComponentMap = {
  [CoverageProduct.LIFE]: LifeInsurance,
  [CoverageProduct.CRITICAL_ILLNESS]: CriticalIllness,
  [CoverageProduct.PERMANENT_DISABILITY]: PermanentDisability,
  [CoverageProduct.TEMPORARY_DISABILITY]: TemporaryDisability,
};

const CoverageSection = () => {
  const availableCoverages = useAvailableCoverages();
  const selectedCoverages = useAppStore.use.selectedCoverages();

  // Coverages are considered main coverages if they are mandatory or pre-selected
  const mainCoverageProducts = availableCoverages
    ?.filter((coverage) => coverage.mandatory || coverage.preSelected)
    .map((coverage) => coverage.coverageProduct);

  // Coverages that are not main coverages are considered additional coverages
  const additionalCoverageProducts = availableCoverages
    ?.filter(
      (coverage) => !mainCoverageProducts?.includes(coverage.coverageProduct)
    )
    .map((coverage) => coverage.coverageProduct);

  return (
    <div data-testid='coverage-section'>
      {mainCoverageProducts && mainCoverageProducts.length > 0 && (
        <Tile
          className={styles.customTile}
          data-testid='main-coverages-container'>
          <div className={styles.mainCoverageList}>
            {mainCoverageProducts.map((coverageProduct) => {
              const Component = coverageComponentMap[coverageProduct];
              const isCoverageSelected =
                selectedCoverages.includes(coverageProduct);
              return (
                <div key={coverageProduct}>
                  <Component displayDetails={isCoverageSelected} />
                </div>
              );
            })}
          </div>
        </Tile>
      )}
      {additionalCoverageProducts && additionalCoverageProducts.length > 0 && (
        <>
          <h2 className={styles.additionalCoveragesTitle}>
            {i18n.t(
              `additionalCoverages.${additionalCoverageProducts.length > 1 ? 'multiple' : 'single'}.title`
            )}
          </h2>
          <p className={styles.additionalCoveragesDescription}>
            {i18n.t(
              `additionalCoverages.${additionalCoverageProducts.length > 1 ? 'multiple' : 'single'}.description`
            )}
          </p>
          <div
            data-testid='additional-coverages-container'
            className={classNames(
              styles.additionalCoveragesContainer,
              styles.additionalCoverageList
            )}>
            {additionalCoverageProducts.map((coverageProduct) => {
              const Component = coverageComponentMap[coverageProduct];
              const isCoverageSelected =
                selectedCoverages.includes(coverageProduct);
              return (
                <div key={coverageProduct}>
                  <Component displayDetails={isCoverageSelected} />
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

export default CoverageSection;
